import { getCurrentDomain } from "@/core/services/domain.service";
import routerWeb from "@/routing/routerWeb";
import initWhiteLabelWebsite from "@/apps/whiteLabelWebsite/whiteLabel/core/infrastructure/service/initWhiteLabelWebsiteService";
import identificationService from "@/core/services/identification.service";
import { setCustomLayoutByOrganization } from "@/core/services/layout.service";
import PublicApp from "@/PublicApp.vue";
import { premiumFeaturesFromConnectorService } from "@/core/services/api/premiumFeaturesFromConnector.service";
import initSharedVueApp from "@/apps/shared/main";
import useErrorStore from "@/core/store/config/errorStore";
import { AxiosError } from "axios";
import { useCartStore } from "@/core/store/cart/cartStore";

export default async () => {
  await Promise.all([
    initWhiteLabelWebsite(routerWeb),
    identificationService.getAnonymousUserWithORD(getCurrentDomain()), // /!\ Inits 3 stores : account, ORD & premiumFeatures. And adds token to authorization (for next API calls) and store it in a cookie.
  ]);

  setCustomLayoutByOrganization(false);

  await useCartStore().initCart(false);

  initSharedVueApp(routerWeb, PublicApp);

  try {
    await premiumFeaturesFromConnectorService.fetchAndSaveEnabledConnectorPremiumFeatures();
  } catch (error) {
    if (error instanceof AxiosError) {
      if (error.response?.status === 401) {
        identificationService.removeAnonymousUser();
      }
    }
    showErrorModal();
  }
};

const showErrorModal = () =>
  useErrorStore().setError({
    reloadPage: true,
  });
